import React, { useEffect, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Col, Row } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedService } from '../../../../store/common/servicesSlice';
import { useNavigate } from 'react-router-dom';

const ServiceListing = () => {

    const { services } = useSelector(state => state?.services);
    const { profileData } = useSelector(state => state?.setting);
    const [defaultActiveColoredKeys, setDefaultActiveColoredKeys] = useState([])


    useEffect(() => {
        if (profileData?.userServices?.length > 0 && services?.length > 0) {
            const keys = profileData?.userServices?.map((item) => {
                return item?.service?.id
            })
            console.log(keys)
            const tempArr = [];
            if (keys?.length > 0) {
                for (let service of services) {
                    console.log("serviceListing: ", service?.id)
                    if (keys.includes(service?.id)) {
                        tempArr.push(service?.id)
                    }
                }
            }
            console.log(tempArr)
            setDefaultActiveColoredKeys(tempArr)
        }
    }, [profileData])


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectedService = (service) => {
        const setServiceAsArray = [{ ...service }]
        dispatch(setSelectedService(setServiceAsArray));
        navigate(`/settings/businessInfo/services/${service?.id}`)
    }

    return (
        <>
            <TitleWithBackNavigation title={'Add Services'} link={'/settings/businessInfo'} />
            <Row justify={'space-between'} className='my-4'>
                <Col lg={17} md={24} sm={24} xs={24} className='mb-2'>
                    {
                        services?.length > 0 ?
                            <ul className='flex flex-col gap-1'>
                                {
                                    services?.map((service) => {
                                        return (
                                            <li className={`flex justify-between px-2 py-3 rounded-md cursor-pointer border border-gray-300 ${defaultActiveColoredKeys?.includes(service?.id) ? 'bg-[#00BF63]' : 'bg-gray-200'} `} key={service?.id} onClick={() => selectedService(service)}>
                                                <span>{service?.name}</span>
                                                {/* <span className='font-semibold'>£ {service?.percentage} </span> */}
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            :
                            <p>No services available</p>
                    }
                </Col>
            </Row>
        </>
    )
}

export default ServiceListing